import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { startSpinner, finishSpinner } from "./ui/spinner";
import { handleErrorApi } from "../helpers/randoms";
import { prepareEmpresaAfiliado } from "../helpers/prepareEmpresaAfiliado";
import { startAlerta } from "./ui/alertas";

const urlBase = process.env.REACT_APP_URL

export const empresasPreafiliadoTraerStart = () => ({
  type: types.empresasPreafiliadoTraerStart,
});

export const empresasPreafiliadoLimpiar = () => ({
  type: types.empresasPreafiliadoLimpiar,
});

export const empresasPreafiliadoTraerError = (error) => ({
  type: types.empresasPreafiliadoTraerError,
  payload: error,
});

export const empresasPreafiliadoInsertError = (error) => ({
  type: types.empresasPreafiliadoInsertError,
  payload: error,
});

export const empresasPreafiliadoTraerSuccess = (payload) => {
  return {
    type: types.empresasPreafiliadoTraerSuccess,
    payload: payload,
  };
};

const empresaPreAfiliadoInsertSuccess = (payload) => {
  return {
    type: types.empresasPreafiliadoInsertSuccess,
    payload: payload,
  };
};

const empresasPreafiliadoUpdated = (empresaAfiliado) => {
  return {
    type: types.empresasPreafiliadoUpdated,
    payload: empresaAfiliado,
  };
}

const empresasPreafiliadoDeleted = (empresaAfiliado) => {
  return {
    type: types.empresasPreafiliadoDeleted,
    payload: empresaAfiliado,
  };
}

export const empresaPreAfiliadoInsertStart = (empresaAfiliado) => {
  return async (dispatch, getState) => {
    try {
      const { afiliadoEncontrado } = getState().preinscripto;
      let response;
      let body;
      let empresaAfiMandar;
      if (afiliadoEncontrado !== null) {
        empresaAfiMandar = {
          ...empresaAfiliado,
          idAfiliado: parseInt(afiliadoEncontrado.id_afiliado),
        };
        const envio = prepareEmpresaAfiliado(empresaAfiMandar)
        dispatch(startSpinner());
        response = await fetchConToken(`EmpresasPreAfiliados`, envio, "POST");
        
      }
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const emp = await response.json();
          dispatch(empresaPreAfiliadoInsertSuccess(emp));
        } else {
          throw new Error(response);
        }
        dispatch(fetchEmpresasPreafiliado(afiliadoEncontrado.id_afiliado))
      } else {
        body = await response.json();
        handleErrorApi(
          dispatch,
          null,
          "Error al dar de alta período",
          body.errores.mensaje
        );
      }
      dispatch(finishSpinner());
    } catch (error) {
      console.log("error en insert empresa PRE afiliado", error);
    }
  };
};

/*
export const empresaPreAfiliadoInsertStartAutogestion = (empresaAfiliado) => {
  return async (dispatch, getState) => {
    try {
      const { afiliadoEncontrado } = getState().preinscripto;
      const { usuarioAutogestion } = getState().userAutogestion;

      let empresaAfiMandar;
      if (afiliadoEncontrado !== null) {
        empresaAfiMandar = {
          ...empresaAfiliado,
          idAfiliado: parseInt(afiliadoEncontrado.id_afiliado),
        };
        dispatch(startSpinner());

        fetch(`${urlBase}/api/EmpresasPreAfiliados`, {
          method: 'POST',
          body: JSON.stringify(empresaAfiMandar),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + usuarioAutogestion.token
          }
        })
          .then(res => res.json())
          .then(res => {
            dispatch(empresaPreAfiliadoInsertSuccess(res));
          })

        dispatch(fetchEmpresasAutogestion(afiliadoEncontrado.id_afiliado))
      }
      dispatch(finishSpinner());
    } catch (error) {
      console.log("error en insert empresa PRE afiliado", error);
    }
  };
};
*/

export const empresasPreafiliadoStartUpdate = (empresaAfiliado) => {
  return async (dispatch) => {
    try {
      const emp = prepareEmpresaAfiliado(empresaAfiliado);
      dispatch(startSpinner());
      const response = await fetchConToken(`EmpresasPreAfiliados/${empresaAfiliado.idEmpresasAfiliados}`, emp, 'PUT');
      let body;
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(startAlerta(`${empresaAfiliado.empresa.denominacion} Actualizada correctamente`, 'success', 'Comando Exitoso'));
          dispatch(empresasPreafiliadoUpdated(empresaAfiliado));
        } else {
          dispatch(startAlerta(response, 'error', 'Error'));
          console.log(response);
          throw new Error(response);
        }
      } else {
        body = await response.json();
        handleErrorApi(
          dispatch,
          null,
          "Error al modificar período",
          body.errores.mensaje
        );
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error, 'error', 'Error'));
      console.log('error en update empresa afiliado', error);
    }
  };
};

export const empresasPreafiliadoStartDelete = (empresaAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(`EmpresasPreAfiliados/${empresaAfiliado.idEmpresasAfiliados}`, {}, 'DELETE');
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(empresasPreafiliadoDeleted(empresaAfiliado.idEmpresasAfiliados));
        } else {
          dispatch(startAlerta(response, 'error', 'Error'));
          throw new Error(response);
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch(startAlerta(error, 'error', 'Error'));
      console.log('error en delete empresa afiliado', error);
    }
  };
};

export const fetchEmpresasPreafiliado = (idPreafiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(empresasPreafiliadoTraerStart());
    const response = await fetchConToken(`EmpresasPreAfiliados/${idPreafiliado}`);
    if (!response.ok) {
      dispatch(empresasPreafiliadoTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length > 0) {
        dispatch(empresasPreafiliadoTraerSuccess(lista));
      }
    }
    dispatch(finishSpinner());
  };
};

export const fetchEmpresasAutogestion = (idPreafiliado) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    dispatch(empresasPreafiliadoTraerStart());
    const state = getState();
    const { usuarioAutogestion } = state.userAutogestion;
    fetch(`${urlBase}/api/EmpresasPreAfiliados/${idPreafiliado}`, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + usuarioAutogestion.token } })
      .then(res => res.json())
      .then(res => {
        if (res.length > 0) {
          dispatch(empresasPreafiliadoTraerSuccess(res));
        }
      })
    dispatch(finishSpinner());
  };
};